import React from 'react';
import { useTranslation } from 'react-i18next';
import type { SeasonStatus } from '../../api/client';
import './SeasonStatusBadge.css';

/**
 * Small pill showing a season's coarse lifecycle status. Shared by the Settings
 * SeasonInfoPanel and the SeasonsSidebar so both render the status identically.
 * Styling lives in SeasonStatusBadge.css (theme tokens + relative units).
 */
const SeasonStatusBadge: React.FC<{ status: SeasonStatus }> = ({ status }) => {
  const { t } = useTranslation();
  return (
    <span className={`season-badge season-badge--${status}`}>
      {t(`courses.seasons.status.${status}`)}
    </span>
  );
};

export default SeasonStatusBadge;
